import {
  Box,
  Center,
  Image,
  Progress,
  Tag,
  Text,
  useToken,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { forwardRef } from "react";
import { useAuth } from "../../Providers/AuthProvider";
// import { getStatusStyle } from "../../utils/generalStyles";

const Course = forwardRef<HTMLDivElement, ICourseCardProps>(
  ({ course, progress, isDisabled }, ref) => {
    const [cardShadow, hoverShadow] = useToken("colors", [
      "cardShadow",
      "cardHoverShadow",
    ]);
    const {} = useAuth();
    const navigate = useNavigate();

    return (
      <Box ref={ref}>
        <Box
          border={"1px solid"}
          borderBottom={"5px solid"}
          borderRadius={"1rem"}
          boxShadow={cardShadow}
          borderColor={isDisabled ? "neutral.950" : "neutral.900"}
          w={"100%"}
          h={{ base: "9rem", md: "10rem" }}
          p={"1rem"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          cursor={isDisabled ? "initial" : "pointer"}
          _hover={
            isDisabled
              ? {}
              : {
                  borderColor: "neutral.700",
                  boxShadow: hoverShadow,
                  bg: "linear-gradient(to top, rgb(58, 58, 58) 0%, rgba(255, 106, 0, 0.0)) 10%",
                }
          }
          _active={
            isDisabled
              ? {}
              : {
                  borderBottom: "3px solid",
                  borderColor: "neutral.900",
                }
          }
          onClick={
            isDisabled
              ? () => {}
              : () => navigate(`/dashboard/course/${course._id}`)
          }
        >
          <Image
            w={{ base: "5rem", md: "5.3rem" }}
            height={{ base: "5rem", md: "5.3rem" }}
            objectFit={"contain"}
            src={course.image}
            objectPosition={"center"}
          />
          <Box mt={"1rem"} width={"full"}>
            {isDisabled ? (
              <Center>
                <Tag mt={".5rem"} colorScheme="green">
                  coming soon
                </Tag>
              </Center>
            ) : (
              <Progress
                colorScheme="green"
                mb={".3rem"}
                h={"0.438rem"}
                value={progress}
              />
            )}
          </Box>
        </Box>
        {/* {(role === Role.SuperAdmin ||
          role === Role.Admin ||
          role === Role.Creator) && (
          <Center>
            <Tag
              mt={"-1.4rem"}
              variant={"solid"}
              alignSelf={"center"}
              colorScheme={getStatusStyle(course.status) as string}
            >
              {course.status}
            </Tag>
          </Center>
        )} */}
        <Box mt={"0.8rem"} w={"100%"}>
          <Text
            color={isDisabled ? "neutral.600" : "neutral.400"}
            fontSize={{ base: "sm", md: "md" }}
            fontWeight={{ base: "bold", lg: "600" }}
            textAlign={"center"}
            mb={"0.875rem"}
          >
            {course.title}
          </Text>
        </Box>
      </Box>
    );
  }
);

export default Course;
